const STORAGE_KEY = 'cm.previewVisitorId'

/**
 * Stable, first-party, random visitor id for preview-link opens. Persisted in
 * localStorage so repeat visits from the same browser reuse it — that's what
 * lets the admin collapse "9 opens" into "1 device, 9 sessions" instead of 9
 * unknown people. NOT PII: a random uuid, no cross-site value, never leaves
 * our own app.
 *
 * Returns '' when storage is unavailable (private mode / blocked) — the redeem
 * CF tolerates an empty visitorId, it just can't sessionize those opens.
 */
export function getOrCreatePreviewVisitorId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing) return existing
    const id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `v-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
    localStorage.setItem(STORAGE_KEY, id)
    return id
  } catch {
    return ''
  }
}
